<template>
  <div id="container">
      <Spinner :show="loading"></Spinner>
      <Header></Header>
      <section ref="content" id="content" class="section notabs">
        <Notification v-if="notification.show" :text="notification.text" :className="notification.className"></Notification>
        <div class="columns is-mobile is-centered">
            <div class="column is-half">
                <div class="card">
                    <a @click="$router.push('/wallet/buy')">
                        <div class="has-text-centered">
                            <span class="icon is-large">
                                <i class="fa fa-money fa-2x"> </i>
                            </span>
                            <span class="title is-4">{{ $t("Buy")}}</span>
                        </div>
                        <div class="card-content has-text-centered">
                            <!-- <p>{{ $t("BuyBody") }}</p> -->
                        </div>
                    </a>
                </div>
            </div>
            <div class="column is-half">
                <div class="card">
                    <a @click="$router.push('/wallet/send')">
                        <div class="has-text-centered">
                            <span class="icon is-large">
                                <i class="fa fa-exchange fa-2x"> </i>
                            </span>
                            <span class="title is-4">{{ $t("Send") }}</span>
                        </div>
                        <div class="card-content has-text-centered">
                            <!-- <p>{{ $t("SendBody") }}</p> -->
                        </div>
                    </a>
                </div>
            </div>
        </div>
        <div class="columns is-mobile is-centered">
            <div class="column is-full">
                <div class="card">
                    <a @click="$router.push('/account/profile')">
                        <div class="has-text-centered">
                            <span class="icon is-large">
                                <i class="fa fa-user fa-2x"> </i>
                            </span>
                            <span class="title is-4">{{ $t("Account") }}</span>
                        </div>
                        <div class="card-content has-text-centered">
                            <!-- <p>{{ $t("AccountBody") }}</p> -->
                        </div>
                    </a>
                </div>
            </div>
        </div>
        <template v-if="hasPermission('Household', 'Edit')">
            <div class="columns is-mobile is-centered">
                <div class="column is-full">
                    <div class="card">
                        <a @click="$router.push('/households/search')">
                            <div class="has-text-centered">
                                <span class="icon is-large">
                                    <i class="fa fa-search fa-2x"> </i>
                                </span>
                                <span class="title is-4">{{ $t("Search households") }}</span>
                            </div>
                            <div class="card-content has-text-centered">
                                <!-- <p>{{ $t("SearchBody") }}</p> -->
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </template>
      </section>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import Notification from "@/components/Notification.vue";
import Spinner from "@/components/Spinner.vue";

export default {
  name: "Home",
  components: {
    Notification,
    Header,
    Spinner
  }
};
</script>
